import { gql } from '@apollo/client'
import PropTypes from '~/lib/propTypes'
import { countryFragment } from '~/graphql/fragments/country'

export const eventResultFragment = gql`
  fragment eventResult on EventResult {
    id
    slug
    name
    startDate
    endDate
    locationName
    cityName
    country {
      ...country
    }
    isVerified
    hasOngoingEventType
  }

  ${countryFragment}
`

export const eventResultFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  slug: PropTypes.string,
  name: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  locationName: PropTypes.string,
  cityName: PropTypes.string,
  country: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  isVerified: PropTypes.bool.isRequired,
  hasOngoingEventType: PropTypes.bool.isRequired,
})
